import { LABELS } from '~/app/constants'

const LABEL_FREQUENCY = 0.1

/**
 *
 */
export default function mockLabels() {
  const labels = []

  if (Math.random() < LABEL_FREQUENCY) {
    const label = LABELS[Math.floor(Math.random() * LABELS.length)].id
    labels.push(label)
  }

  return labels
}
